module.exports = __webpack_public_path__ + "img/gb-whatsapp-apk.67dd0606.png";